import { GetDeal_deal_paymentInfo } from '../graphql/queries/__generated__/GetDeal';

export const paymentService = {
  getLastTransaction: (paymentInfo: GetDeal_deal_paymentInfo[]): GetDeal_deal_paymentInfo => {
    return paymentInfo?.reduce((acc: GetDeal_deal_paymentInfo, current: GetDeal_deal_paymentInfo) => {
      return acc.transactionTime > current.transactionTime ? acc : current;
    }, {} as GetDeal_deal_paymentInfo);
  },
};
